import { Grid } from '@design-system';

import { InsightListStoryblok } from '../types/generated-storyblok';
import { ContentInsight } from './Journals/ContentInsight';

interface ContentBlockInsightsProps {
  blok: InsightListStoryblok;
}

export const ContentBlockInsights = ({ blok }: ContentBlockInsightsProps) => (
  <Grid className="gap-y-6" columns={4}>
    {blok.insights.map((insight) => (
      <ContentInsight key={insight._uid} blok={insight} variant="card" />
    ))}
  </Grid>
);
